import styled from "styled-components";

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-size: ${({ size = 22 }) => `${size}px`};
  line-height: 1;
  color: ${({ theme }) => theme.colors.text};
  letter-spacing: -0.02em;
`;

const Mark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ size = 22 }) => `${size + 6}px`};
  height: ${({ size = 22 }) => `${size + 6}px`};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.accent};
  color: #fff;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-style: italic;
  font-size: ${({ size = 22 }) => `${size - 4}px`};
`;

const Word = styled.span`
  font-style: italic;
  & em {
    font-style: italic;
    color: ${({ theme }) => theme.colors.accent};
  }
`;

const Logo = ({ size = 22 }) => (
  <Wrap size={size} aria-label="Carparky">
    <Mark size={size}>c</Mark>
    <Word>
      car<em>parky</em>
    </Word>
  </Wrap>
);

export default Logo;
